import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal, Overline } from "./Reveal";
import { CHAPTERS, ABOUT_IMAGE, ROLES } from "../../data/content";

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="about" data-testid="about-section" className="relative py-28 lg:py-40 bg-ink">
      <div className="max-w-[88rem] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Sticky image + intro */}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <Reveal>
                <Overline>The Woman of Faith</Overline>
              </Reveal>
              <Reveal delay={0.05}>
                <h2 className="mt-6 font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tighter">
                  A devoted heart,<br />
                  <span className="text-gold-gradient italic">an unlimited vision.</span>
                </h2>
              </Reveal>
              <Reveal delay={0.1}>
                <p className="mt-8 text-white/60 leading-relaxed max-w-md">
                  Wife to David Lindsey and proud mother of four, Teresa's passion for
                  ministry, creativity, and empowering others has impacted lives through
                  music, leadership, and the arts.
                </p>
              </Reveal>

              <Reveal delay={0.15}>
                <div className="relative mt-10 overflow-hidden rounded-sm border border-gold/15">
                  <motion.img
                    style={{ y }}
                    src={ABOUT_IMAGE}
                    alt="Teresa ministering"
                    className="w-full h-[420px] object-cover object-[center_15%] scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink via-transparent to-transparent" />
                </div>
              </Reveal>

              <Reveal delay={0.2}>
                <div className="mt-8 flex flex-wrap gap-2">
                  {ROLES.map((r) => (
                    <span
                      key={r}
                      className="px-3 py-1.5 text-[11px] uppercase tracking-[0.15em] text-white/60 border border-white/12 rounded-full"
                    >
                      {r}
                    </span>
                  ))}
                </div>
              </Reveal>
            </div>
          </div>

          {/* Manifesto chapters */}
          <div className="lg:col-span-7 lg:pt-16">
            <div className="flex flex-col">
              {CHAPTERS.map((c, i) => (
                <Reveal key={c.no} delay={i * 0.05}>
                  <div className="group py-10 border-t border-white/10 first:border-t-0 lg:pl-10">
                    <div className="flex items-baseline gap-6">
                      <span className="font-serif text-5xl lg:text-6xl text-gold/25 group-hover:text-gold/60 transition-colors duration-500 leading-none">
                        {c.no}
                      </span>
                      <div>
                        <h3 className="font-serif text-3xl lg:text-4xl font-light tracking-tight text-white">
                          {c.title}
                        </h3>
                        <p className="mt-4 text-white/60 leading-relaxed max-w-xl">{c.body}</p>
                      </div>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
